import { render, staticRenderFns } from "./footer_index.vue?vue&type=template&id=e1514016&scoped=true"
import script from "./footer_index.vue?vue&type=script&lang=js"
export * from "./footer_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1514016",
  null
  
)

export default component.exports